<template>
    <div class="counter input-group input-group-sm">
        <div class="input-group-prepend">
            <button :class="['btn', {disabled: disabled}]" :disabled="disabled" @click="decrease()">
                <span class="material-icon icon-remove"></span>
            </button>
        </div>
        <input type="text" class="form-control" v-model="value"
               @input="isNumber($event.target.value)">
        <div class="input-group-append">
            <button :class="['btn', {disabled: disabled}]" :disabled="disabled" @click="increase()">
                <span class="material-icon icon-add"></span>
            </button>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .counter {
        width: 120px;
        color: var(--text-color);
        border-radius: 4px;
        border: 1px solid var(--bg-secondary-color-dark);
        background-color: var(--bg-color);

        input,
        .btn {
            padding-top: 13px !important;
            padding-bottom: 13px !important;
            border-radius: 0;
            border: none;
            color: var(--text-color);
            background-color: transparent;
        }

        input {
            height: 46px !important;
            font-size: 1rem;
            padding-left: 0;
            padding-right: 0;
            text-align: center;
        }

        .input-group-prepend .btn {
            padding-left: 12px;
        }

        .input-group-append .btn {
            padding-right: 12px;
        }
    }
</style>

<script>
  import counter from 'src/mixins/counterComponent';

  export default {
    mixins: [counter],
  };
</script>
